// extracted by mini-css-extract-plugin
var _1 = "ExternalFile_input__fc5d0";
var _2 = "ExternalFile_label__07eda";
var _3 = "ExternalFile_root__63339";
export { _1 as "input", _2 as "label", _3 as "root" }
